var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-common",style:(!_vm.module.base.m ? 'margin-top:0' : '')},[_c('van-search',{attrs:{"disabled":"","shape":"round","placeholder":_vm.module.style.text,"background":_vm.module.style.bgcolor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }